const COOKIE_NAME = 'cs_returning';

export function setReturningCookie(): void {
  const maxAge = 365 * 24 * 60 * 60; // 1 year in seconds
  document.cookie = `${COOKIE_NAME}=1; max-age=${maxAge}; path=/; SameSite=Lax`;
}

export function hasReturningCookie(): boolean {
  return document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));
}
